module.exports = __webpack_public_path__ + "static/media/general-error.34b3303d.png";